module.exports = __webpack_public_path__ + "img/stickers-contrat-travail.12462d39.jpg";